"use client";
import { component } from "@gnist/component-utils";
import { lozengeRecipe } from "./lozenge.css.js";
const Lozenge = component("Lozenge", lozengeRecipe, "span");
export {
  Lozenge
};
